import * as React from 'react'
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel'
import styled from 'styled-components'

const apAtomName = {ap_atom_name: 'formControlLabelAtom'}

const FormControlLabelAtom = styled((props: FormControlLabelProps) => (
  <FormControlLabel {...apAtomName} {...props} />
))``

export default FormControlLabelAtom
